document.addEventListener('DOMContentLoaded', function () {
    let estimate_block = document.querySelectorAll('body.estimate');
    if (!estimate_block.length) {
        return;
    }
    let rows = document.querySelectorAll('.estimate__block-roof-surfaces_table tbody tr');
    let overlay = document.querySelector('.estimate__overlay');
    rows.forEach(row => {
        if (row.classList.contains('estimate__block-roof-surfaces_group-facets') || row.classList.contains('estimate__block-roof-surfaces_group-row')) {
            return;
        }
        row.addEventListener('click', function (e) {
            if (e.target.closest('.estimate__block-roof-surfaces_details_close')) {
                return;
            }
            overlay.classList.toggle('active');
            let details = row.querySelector('.estimate__block-roof-surfaces_details');
            details.classList.toggle('active');
        });
    });

    let close_btns = document.querySelectorAll('.estimate__block-roof-surfaces_details_close');
    close_btns.forEach(close_btn => {
        close_btn.addEventListener('click', function () {
            overlay.classList.remove('active');
            let details = document.querySelector('.estimate__block-roof-surfaces_details.active');
            details.classList.remove('active');
        });
    });

    //overlay click handler
    overlay.addEventListener('click', function () {
        overlay.classList.remove('active');
        let details = document.querySelector('.estimate__block-roof-surfaces_details.active');
        details.classList.remove('active');
    });

    let map_prices_btn = document.querySelectorAll('.estimate__block-map_prices-btn');
    map_prices_btn.forEach(btn => {
        btn.addEventListener('click', function (e) {
            let parent_block = e.target.closest('.estimate__block-map');
            let btn_show = parent_block.querySelector('.estimate__block-map_prices-btn-show');
            let btn_hide = parent_block.querySelector('.estimate__block-map_prices-btn-hide');
            let mapPlaceholder = parent_block.querySelector('.estimate__block-map-placeholder');
            btn_show.classList.toggle('active');
            btn_hide.classList.toggle('active');
            const b64 = mapPlaceholder.dataset.jsonB64;
            const json = atob(b64);
            const roofFacets = JSON.parse(json);
            // Toggle price visibility in labels
            showPricesInLabels(btn_hide.classList.contains('active'), roofFacets.individualFacets);
        });
    });

    //complex click handlers
    let complex_rows = document.querySelectorAll('.estimate__block-roof-surfaces_table .estimate__block-roof-surfaces_group-facet-row');
    if (complex_rows.length) {
        complex_rows.forEach(row => {
            row.addEventListener('click', function (e) {
                if (e.target.closest('.estimate__block-roof-surfaces_details_close')) {
                    return;
                }
                overlay.classList.toggle('active');
                let details = row.querySelector('.estimate__block-roof-surfaces_group-facet-details');
                details.classList.toggle('active');
            });
        });
    }

    let group_rows = document.querySelectorAll('.estimate__block-roof-surfaces_group-row');
    if (group_rows.length) {
        group_rows.forEach(row => {
            row.addEventListener('click', function (e) {
                const groupId = row.dataset.groupId;
                if (groupId) {
                    window.toggleGroupExpansion(groupId);
                }
            });
        });
    }

    let show_all_btns = document.querySelectorAll('.estimate__block-roof-surfaces-show-all-btn');
    if (show_all_btns.length) {
        show_all_btns.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let parent = e.target.closest('.estimate__block-roof-surfaces');
                let group_rows = parent.querySelectorAll('.estimate__block-roof-surfaces_group-facets');
                if (group_rows.length) {
                    group_rows.forEach(row => {
                        row.style.display = 'table-row';
                    });
                }
            })
        })
    }

    let hide_all_btns = document.querySelectorAll('.estimate__block-roof-surfaces-hide-all-btn');
    if (hide_all_btns.length) {
        hide_all_btns.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let parent = e.target.closest('.estimate__block-roof-surfaces');
                let group_rows = parent.querySelectorAll('.estimate__block-roof-surfaces_group-facets');
                if (group_rows.length) {
                    group_rows.forEach(row => {
                        row.style.display = 'none';
                    });
                }
            })
        })
    }

    // Sorting functionality for roof surfaces table
    let sort_selects = document.querySelectorAll('.estimate__block-roof-surfaces_sort-select');
    if (sort_selects.length) {
        sort_selects.forEach(select => {
            // Set default sorting to area
            select.value = 'area';

            select.addEventListener('change', function (e) {
                const sortBy = e.target.value;
                const tableContainer = e.target.closest('.estimate__block-roof-surfaces');

                // Only sort if this is a complex project (more than 20 facets)
                const table = tableContainer.querySelector('.estimate__block-roof-surfaces_table');
                if (table && table.classList.contains('estimate__block-roof-surfaces_table-grouped')) {
                    sortTable(tableContainer, sortBy);
                }
            });
        });
    }

    /**
     * Sort roof surfaces table by groups (parent + children together)
     * @param {HTMLElement} tableContainer - The container element
     * @param {string} sortBy - Sort criteria: 'area', 'helning', 'direction'
     */
    function sortTable(tableContainer, sortBy) {
        const tbody = tableContainer.querySelector('.estimate__block-roof-surfaces_table tbody');
        if (!tbody) return;

        const rows = Array.from(tbody.querySelectorAll('tr'));

        // Separate group rows from other rows
        const groupRows = rows.filter(row => row.classList.contains('estimate__block-roof-surfaces_group-row'));
        const otherRows = rows.filter(row => !row.classList.contains('estimate__block-roof-surfaces_group-row'));

        if (groupRows.length > 0) {
            // Sort groups (parent rows only, children follow their parents)
            const sortedGroups = sortGroups(groupRows, sortBy);

            // Reconstruct table with sorted groups and their children
            tbody.innerHTML = '';
            sortedGroups.forEach(groupRow => {
                tbody.appendChild(groupRow);

                // Find and append all child rows for this group
                const groupId = groupRow.dataset.groupId;
                const childRows = otherRows.filter(row => row.classList.contains(groupId));
                childRows.forEach(childRow => {
                    tbody.appendChild(childRow);
                });
            });

            // Add remaining individual facet rows (not part of groups) - also sorted
            const remainingFacetRows = otherRows.filter(row => {
                const rowClasses = Array.from(row.classList);
                return !rowClasses.some(cls => groupRows.some(group => group.dataset.groupId === cls));
            });

            if (remainingFacetRows.length > 0) {
                // Sort remaining individual facets
                const sortedRemaining = sortIndividualFacets(remainingFacetRows, sortBy);
                sortedRemaining.forEach(row => {
                    tbody.appendChild(row);
                });
            }
        }
    }

    /**
     * Sort group rows by data attributes
     * @param {Array} groupRows - Array of group row elements
     * @param {string} sortBy - Sort criteria
     * @returns {Array} Sorted group rows
     */
    function sortGroups(groupRows, sortBy) {
        return groupRows.sort((a, b) => {
            let valueA, valueB;

            switch (sortBy) {
                case 'area':
                    valueA = parseFloat(a.dataset.sortArea) || 0;
                    valueB = parseFloat(b.dataset.sortArea) || 0;
                    return valueB - valueA; // Descending for area

                case 'helning':
                    valueA = parseFloat(a.dataset.sortHelning) || 0;
                    valueB = parseFloat(b.dataset.sortHelning) || 0;
                    return valueB - valueA; // Descending for slope

                case 'direction':
                    valueA = parseFloat(a.dataset.sortDirection) || 0;
                    valueB = parseFloat(b.dataset.sortDirection) || 0;
                    return valueA - valueB; // Ascending for direction (North = 0, East = 90, South = 180, West = 270)

                default:
                    return 0;
            }
        });
    }

    /**
     * Sort individual facet rows by data attributes
     * @param {Array} facetRows - Array of individual facet row elements
     * @param {string} sortBy - Sort criteria
     * @returns {Array} Sorted facet rows
     */
    function sortIndividualFacets(facetRows, sortBy) {
        return facetRows.sort((a, b) => {
            let valueA, valueB;

            switch (sortBy) {
                case 'area':
                    valueA = parseFloat(a.dataset.sortArea) || 0;
                    valueB = parseFloat(b.dataset.sortArea) || 0;
                    return valueB - valueA; // Descending for area

                case 'helning':
                    valueA = parseFloat(a.dataset.sortHelning) || 0;
                    valueB = parseFloat(b.dataset.sortHelning) || 0;
                    return valueB - valueA; // Descending for slope

                case 'direction':
                    valueA = parseFloat(a.dataset.sortDirection) || 0;
                    valueB = parseFloat(b.dataset.sortDirection) || 0;
                    return valueA - valueB; // Ascending for direction (North = 0, East = 90, South = 180, West = 270)

                default:
                    return 0;
            }
        });
    }

    // Search functionality for roof surfaces table
    let search_inputs = document.querySelectorAll('.estimate__block-roof-surfaces_search-input');
    if (search_inputs.length) {
        search_inputs.forEach(input => {
            input.addEventListener('input', function (e) {
                const searchTerm = e.target.value.toLowerCase();
                const tableContainer = e.target.closest('.estimate__block-roof-surfaces');
                filterTableByName(tableContainer, searchTerm);
            });
        });
    }

    /**
     * Filter table rows based on data-name attribute
     * @param {HTMLElement} tableContainer - The container element
     * @param {string} searchTerm - Search term to filter by
     */
    function filterTableByName(tableContainer, searchTerm) {
        const tbody = tableContainer.querySelector('.estimate__block-roof-surfaces_table tbody');
        if (!tbody) return;

        const rows = Array.from(tbody.querySelectorAll('tr'));

        rows.forEach(row => {
            const dataName = row.dataset.name ? row.dataset.name.toLowerCase() : '';
            const shouldShow = !searchTerm || dataName.includes(searchTerm);

            if (shouldShow) {
                row.style.display = '';
            } else {
                row.style.display = 'none';
            }
        });
    }

    // Filter functionality for main vs all facets
    let main_facets_btns = document.querySelectorAll('.estimate__block-roof-surfaces_main-facets-btn');
    if (main_facets_btns.length) {
        main_facets_btns.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let parent = e.target.closest('.estimate__block-roof-surfaces');
                let button = parent.querySelector('.estimate__block-roof-surfaces_main-facets-btn');
                let table = parent.querySelector('.estimate__block-roof-surfaces_table');

                // Toggle between showing all facets and only main facets
                if (button.classList.contains('facets_all')) {
                    button.classList.remove('facets_all');
                    button.classList.add('facets_mainonly');
                    table.classList.remove('facets_all');
                    table.classList.add('facets_mainonly');
                } else {
                    button.classList.remove('facets_mainonly');
                    button.classList.add('facets_all');
                    table.classList.remove('facets_mainonly');
                    table.classList.add('facets_all');
                }
            })
        })
    }

    //

    let polygonsPerMap = [];
    let roofPolygons = [];
    let mapInstance = null;
    let labelPositions = []; // Store label positions for collision detection

    /**
     * Check if two rectangles overlap
     * @param {Object} rect1 - {x, y, width, height}
     * @param {Object} rect2 - {x, y, width, height}
     * @returns {boolean} True if rectangles overlap
     */
    function rectanglesOverlap(rect1, rect2) {
        return !(rect1.x + rect1.width < rect2.x ||
            rect2.x + rect2.width < rect1.x ||
            rect1.y + rect1.height < rect2.y ||
            rect2.y + rect2.height < rect1.y);
    }

    /**
     * Find non-overlapping position for label
     * @param {Object} preferredPos - {x, y, width, height}
     * @param {Array} existingPositions - Array of existing label positions
     * @param {Object} polygonBounds - Leaflet bounds object
     * @returns {Object} Adjusted position {x, y}
     */
    function findNonOverlappingPosition(preferredPos, existingPositions, polygonBounds) {
        const labelWidth = preferredPos.width;
        const labelHeight = preferredPos.height;

        // Try different positions around the polygon center
        const center = polygonBounds.getCenter();
        const centerPoint = mapInstance.latLngToContainerPoint(center);

        // Define possible positions (top-left, top, top-right, left, center, right, etc.)
        const offsets = [
            {x: -40, y: -30},  // top-left (preferred)
            {x: 0, y: -30},    // top
            {x: 40, y: -30},   // top-right
            {x: -40, y: 0},    // left
            {x: 40, y: 0},     // right
            {x: -40, y: 30},   // bottom-left
            {x: 0, y: 30},     // bottom
            {x: 40, y: 30},    // bottom-right
            {x: 0, y: 0}       // center (fallback)
        ];

        for (let offset of offsets) {
            const testPos = {
                x: centerPoint.x + offset.x,
                y: centerPoint.y + offset.y,
                width: labelWidth,
                height: labelHeight
            };

            // Check if this position overlaps with any existing labels
            let hasOverlap = false;
            for (let existingPos of existingPositions) {
                if (rectanglesOverlap(testPos, existingPos)) {
                    hasOverlap = true;
                    break;
                }
            }

            if (!hasOverlap) {
                return {x: offset.x, y: offset.y};
            }
        }

        // If all positions overlap, return the preferred position anyway
        return {x: -40, y: -30};
    }

    function blendHexOverBg(topHex, alpha = 0.3, bgHex = "#FFFFFF", mode = "round") {
        function toRGB(hex) {
            let h = hex.replace(/^#/, "");
            if (h.length === 3) h = h.split("").map(c => c + c).join("");
            const n = parseInt(h, 16);
            return {r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255};
        }

        function toHex(r, g, b) {
            return (
                "#" +
                [r, g, b]
                    .map(v => {
                        const s = v.toString(16).toUpperCase();
                        return s.length === 1 ? "0" + s : s;
                    })
                    .join("")
            );
        }

        const top = toRGB(topHex);
        const bg = toRGB(bgHex);

        const mix = (t, b) => {
            const v = alpha * t + (1 - alpha) * b;
            return mode === "floor" ? Math.floor(v) : Math.round(v);
        };

        const r = mix(top.r, bg.r);
        const g = mix(top.g, bg.g);
        const b = mix(top.b, bg.b);

        return toHex(r, g, b);
    }

    function getPolygonStylesWithColor(isSelected = false, groupColor = null) {
        const baseColor = groupColor || '#3B68FC';
        if (isSelected) {
            return {
                color: '#000000',
                weight: 1.5,
                opacity: 1,
                fillColor: baseColor,
                fillOpacity: 1,
                dashArray: null
            };
        } else {
            return {
                color: '#000000',
                weight: 1.5,
                opacity: 1,
                fillColor: blendHexOverBg(baseColor),
                fillOpacity: 1,
                dashArray: null
            };
        }
    }

    /**
     * Add a roof polygon to the map and manage it
     * @param {Array} coordinates - Array of coordinate pairs
     * @param {Object} facetData - Original facet data
     * @param {number} index - Index of the facet for unique identification
     */
    function addRoofPolygon(coordinates, facetData = null, index = 0) {
        try {
            // Prepare facet data with unique ID
            const processedFacetData = {
                ...facetData,
                facetId: facetData.facetId || `facet_${index}_${Date.now()}`
            };

            // Get initial styles (selected state - all polygons start selected)
            // Use group color if available, otherwise use default
            const groupColor = processedFacetData.groupInfo ? processedFacetData.groupInfo.groupColor : null;
            const polygonStyles = getPolygonStylesWithColor(true, groupColor);
            const polygon = L.polygon(coordinates, polygonStyles);
            const groupId = processedFacetData.groupInfo ? processedFacetData.groupInfo.groupId : null;

            // Set initial selection state (selected by default)
            polygon.isSelected = true;
            polygon.facetId = processedFacetData.facetId;
            polygon.facetData = processedFacetData;
            polygon.facetPrice = facetData.Price;

            // Add permanent label with roof information
            if (processedFacetData) {
                const buildingNumber = (processedFacetData.buildingIndex || 0) + 1;
                const roofNumber = index + 1;
                //console.log(facetData);
                const getLabelContent = () => {

                    return `
                    <div style="display: flex; flex-direction:column; align-items: center; justify-content: center; width: 100%; height: 50px;">
                         <div style="font-family: 'Poppins', sans-serif; padding: 4px 8px; border-radius: 50%; overflow: hidden; background: #fff; width: 30px; height: 30px;">
                             <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;font-weight: 600; font-size: 13px; color: #111827;">
                                 ${roofNumber}
                             </div>
                         </div>
                          <div style="color:#fff;text-shadow: 1px 1px 2px rgba(0,0,0,1);font-family: 'Poppins', sans-serif;font-size: 13px;font-weight: 600;">
                            ${polygon.facetPrice}
                         </div>
                     </div>
                     `;
                };

                // Store polygon data for later label positioning
                polygon.labelContent = getLabelContent();
                polygon.roofNumber = roofNumber;
                polygon.buildingNumber = buildingNumber;
                polygon.facetId = facetData.Id;

                // Add custom CSS for label if not already added
                if (!document.querySelector('#roof-label-styles')) {
                    const labelStyles = document.createElement('style');
                    labelStyles.id = 'roof-label-styles';
                    labelStyles.textContent = `
                         .roof-polygon-label {
                             background: transparent !important;
                             border: none !important;
                             border-radius: 0 !important;
                             box-shadow: none !important;
                             color: inherit !important;
                             pointer-events: none !important;
                         }
                         .roof-polygon-label::before {
                             display: none !important;
                         }
                     `;
                    document.head.appendChild(labelStyles);
                }
            }

            // Add click event for selection toggle
            polygon.on('click', function (e) {
                /*
                L.DomEvent.stopPropagation(e);

                // Try different possible facet ID sources
                let facet_id = polygon.facetData?.Id || polygon.facetId || polygon.facetData?.id;

                console.log('Map polygon clicked');
                console.log('Polygon facetData:', polygon.facetData);
                console.log('Polygon facetId:', polygon.facetId);
                console.log('Extracted facet ID:', facet_id);

                if (!facet_id) {
                    console.error('No facet ID found in polygon data');
                    return;
                }

                // First try to find individual facet row (for non-complex projects)
                let roof_table_row = document.querySelector('.estimate__block-roof-surfaces_table tbody #id_'+facet_id);

                // If not found, look for group facet row (for complex projects)
                if (!roof_table_row) {
                    roof_table_row = document.querySelector('.estimate__block-roof-surfaces_group-facet-row[data-facet-id="' + facet_id + '"]');
                    console.log('Looking for group facet row with ID:', facet_id);
                    console.log('Available group facet rows:', document.querySelectorAll('.estimate__block-roof-surfaces_group-facet-row').length);
                }

                console.log('Found table row:', roof_table_row);

                // Show popup if we found a corresponding row
                if (roof_table_row) {
                    // For individual facet rows
                    if (roof_table_row.id && roof_table_row.id.startsWith('id_')) {
                        console.log('Showing popup for individual facet');
                        const details = roof_table_row.querySelector('.estimate__block-roof-surfaces_details');
                        console.log('Found details element:', details);
                        if (details) {
                            console.log('Details classes before:', details.className);
                            details.classList.toggle('active');
                            console.log('Details classes after:', details.className);
                            console.log('Details visibility:', details.style.display);
                            console.log('Details computed style:', window.getComputedStyle(details));
                        } else {
                            console.error('No details element found in row:', roof_table_row);
                            console.log('Row HTML:', roof_table_row.innerHTML);
                        }
                    }
                    // For group facet rows
                    else if (roof_table_row.classList.contains('estimate__block-roof-surfaces_group-facet-row')) {
                        console.log('Showing popup for group facet');
                        const details = roof_table_row.querySelector('.estimate__block-roof-surfaces_group-facet-details');
                        if (details) {
                            // Just toggle the details without overlay for now
                            details.classList.toggle('active');
                            console.log('Toggled group facet details visibility');
                        }
                    }
                } else {
                    console.log('No table row found for facet ID:', facet_id);
                    console.log('Available individual rows:', document.querySelectorAll('tr[id^="id_"]').length);
                    console.log('Available group facet rows:', document.querySelectorAll('.estimate__block-roof-surfaces_group-facet-row').length);
                }

                 */
                L.DomEvent.stopPropagation(e);
                let facet_id = polygon.facetData.Id;
                let roof_table_row = document.querySelector('.estimate__block-roof-surfaces_table tbody #id_' + facet_id);
                let details = roof_table_row.querySelector('.estimate__block-roof-surfaces_details');
                details.classList.toggle('active');
                overlay.classList.toggle('active');

                if (groupId) {
                    let group_rows = document.querySelectorAll('.estimate__block-roof-surfaces_table tbody .' + groupId);
                    group_rows.forEach(row => {
                        row.style.display = 'table-row';
                    });
                } else {
                    let group_row = roof_table_row.closest('.estimate__block-roof-surfaces_group-facets');
                    if (group_row) {
                        group_row.style.display = 'table-row';
                    }
                }


            });

            // Add hover effects
            polygon.on('mouseover', function (e) {
                if (!polygon.isSelected) {
                    const groupColor = polygon.facetData.groupInfo ? polygon.facetData.groupInfo.groupColor : null;
                    const hoverStyles = getPolygonStylesWithColor(false, groupColor);
                    hoverStyles.fillOpacity = .7;
                    hoverStyles.weight = 1.5;
                    polygon.setStyle(hoverStyles);
                }
            });

            polygon.on('mouseout', function (e) {
                if (!polygon.isSelected) {
                    const groupColor = polygon.facetData.groupInfo ? polygon.facetData.groupInfo.groupColor : null;
                    const normalStyles = getPolygonStylesWithColor(false, groupColor);
                    polygon.setStyle(normalStyles);
                }
            });

            polygon.addTo(mapInstance);
            roofPolygons.push(polygon);
            polygonsPerMap.push(polygon);

            return polygon;
        } catch (error) {
            console.error('Error adding roof polygon:', error);
            return null;
        }
    }

    function initMap() {
        // Check if Leaflet is loaded
        if (typeof L === 'undefined') {
            console.error('Leaflet is not loaded.');
            return;
        }
        const apiKey = window.wdsCalculatorData.apiKeys.map ?? '';
        if (!apiKey) {
            console.error('Map API key not found.');
            return;
        }

        const mapPlaceholder = document.querySelectorAll('.estimate__block-map-placeholder');
        if (!mapPlaceholder) {
            console.error('Map placeholder not found.');
            return;
        }

        mapPlaceholder.forEach(mapPlaceholder => {
            polygonsPerMap = [];
            let center, zoom;
            let x = mapPlaceholder.dataset.latitude;
            let y = mapPlaceholder.dataset.longitude;
            if (!x || !y) {
                console.error('Map coordinates not found.');
                return;
            }

            center = [x, y];
            zoom = 21;

            mapInstance = L.map(mapPlaceholder, {
                zoomControl: false,
                scrollWheelZoom: false
            }).setView(center, zoom);

            const satelittLayer = L.tileLayer(
                `https://waapi.webatlas.no/maptiles/tiles/webatlas-orto-newup/wa_grid/{z}/{x}/{y}.jpeg?APITOKEN=${apiKey}`,
                {
                    // attribution: ' 2020 Norkart AS/Geovekst og kommunene/OpenStreetMap/NASA/EEA CLC2006/Meti/Plan- og bygningsetaten, Oslo Kommune',
                    maxZoom: 22,
                    minZoom: 15,
                }
            );

            const kartLayer = L.tileLayer(
                `https://waapi.webatlas.no/maptiles/tiles/webatlas-gray-vektor/wa_grid/{z}/{x}/{y}.png?APITOKEN=${apiKey}`,
                {
                    // attribution: ' 2020 Norkart AS/Geovekst og kommunene/OpenStreetMap/NASA/EEA CLC2006/Meti/Plan- og bygningsetaten, Oslo Kommune',
                    maxZoom: 22,
                    minZoom: 15,
                }
            );

            const baseMaps = {
                "Satelitt": satelittLayer,
                "Kart": kartLayer
            };

            kartLayer.addTo(mapInstance);
            L.control.layers(baseMaps, null, {position: 'topright'}).addTo(mapInstance);
            L.control.zoom({zoomInTitle: 'Zoom inn', oomOutTitle: 'Zoom ut', position: 'topright'}).addTo(mapInstance);

            const b64 = mapPlaceholder.dataset.jsonB64;
            const json = atob(b64);
            const data = JSON.parse(json);

            // Handle both old and new data formats
            let roofFacets = [];
            let facetGroups = [];
            let useGrouping = false;
            let groupColors = [];

            if (data.individualFacets && data.facetGroups) {
                // New format with grouping support
                roofFacets = data.individualFacets;
                facetGroups = data.facetGroups;
                useGrouping = data.useGrouping;
                groupColors = data.groupColors;
            } else {
                // Old format - just individual facets
                roofFacets = data;
            }

            // Add group information to facets for map rendering
            if (useGrouping && facetGroups.length > 0) {
                // Create a lookup map for facet ID to group index
                const facetToGroupMap = {};
                facetGroups.forEach((group, groupIndex) => {
                    group.facets.forEach(facet => {
                        facetToGroupMap[facet.Id] = {
                            groupIndex: groupIndex,
                            groupColor: groupColors[groupIndex] || '#3B68FC',
                            groupId: group.groupId
                        };
                    });
                });

                // Add group information to each facet
                roofFacets.forEach(facet => {
                    if (facetToGroupMap[facet.Id]) {
                        facet.groupInfo = facetToGroupMap[facet.Id];
                    }
                });
            }

            // Sort roofFacets by Areal in descending order (largest first)
            /*
            roofFacets.sort((a, b) => {
                const areaA = parseFloat(a.Areal) || 0;
                const areaB = parseFloat(b.Areal) || 0;
                return areaB - areaA; // Sort from largest to smallest
            });
             */
            console.log('roofFacets sorted', roofFacets);

            let successfulPolygons = 0;
            roofFacets.forEach((facet, index) => {
                if (facet.Geometri) {
                    try {
                        const geometry = JSON.parse(facet.Geometri);

                        if (geometry.type === 'Polygon' && geometry.coordinates && geometry.coordinates[0]) {
                            const rawCoords = geometry.coordinates[0];
                            // Convert from GeoJSON format [lng, lat] to Leaflet format [lat, lng]
                            const polygonCoords = rawCoords.map(p => [p[1], p[0]]);

                            // Add polygon with facet data (which now includes buildingIndex)
                            const polygon = addRoofPolygon(polygonCoords, facet, index);

                            if (polygon) {
                                successfulPolygons++;
                            }
                        } else {
                            console.warn(`Facet ${index + 1}: Invalid or non-polygon geometry`, geometry);
                        }
                    } catch (e) {
                        console.error(`Error parsing Geometri JSON for facet ${index + 1}:`, e, facet.Geometri);
                    }
                } else {
                    console.warn(`Facet ${index + 1}: No Geometri data`, facet);
                }
            });
            // Fit map to show all polygons if any were added
            if (polygonsPerMap.length > 0) {
                const group = new L.featureGroup(polygonsPerMap);
                mapInstance.fitBounds(group.getBounds(), {padding: [20, 20]});

                // Apply labels with collision detection after map is ready
                setTimeout(() => {
                    applyLabelsWithCollisionDetection();
                }, 100);
            }
        });

    }

    /**
     * Apply labels to all polygons with collision detection
     */
    function applyLabelsWithCollisionDetection() {
        labelPositions = []; // Reset label positions

        // Approximate label dimensions (will be more accurate after rendering)
        const labelWidth = 50;
        const labelHeight = 30;

        roofPolygons.forEach((polygon) => {
            if (!polygon.labelContent) return;

            // Apply tooltip with calculated offset
            polygon.bindTooltip(polygon.labelContent, {
                permanent: false,
                direction: 'auto',
                className: 'roof-polygon-label'
            });
        });
    }

    /**
     * Show or hide prices in polygon labels
     * @param {boolean} showPrices - Whether to show prices in labels
     */
    function showPricesInLabels(showPrices = false, roofFacets = []) {
        roofPolygons.forEach((polygon) => {
            let to_return = true;
            //return if ids do not match
            for (const facet of roofFacets) {
                if (facet.Id === polygon.facetId) {
                    //console.log('not match',facet.Id,polygon.facetId);
                    to_return = false;
                    break;
                }
            }
            if (to_return) return;

            if (!polygon.labelContent) return;
            // Get the current tooltip if it exists
            const tooltip = polygon.getTooltip();
            if (tooltip) {
                // Remove existing tooltip
                polygon.unbindTooltip();
            }

            if (showPrices) {
                // show prices
                const withPrices = `
                    <div style="display: flex; flex-direction:column; align-items: center; justify-content: center; width: 100%; height: 50px;">
                        <div style="font-family: 'Poppins', sans-serif; padding: 4px 8px; border-radius: 50%; overflow: hidden; background: #fff; width: 30px; height: 30px;">
                            <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;font-weight: 600; font-size: 13px; color: #111827;">
                                ${polygon.roofNumber}
                            </div>
                        </div>
                         <div style="color:#fff;text-shadow: 1px 1px 2px rgba(0,0,0,1);font-family: 'Poppins', sans-serif;font-size: 13px;font-weight: 600;">
                            ${polygon.facetPrice}
                         </div>
                     </div>
                `;
                polygon.labelContent = withPrices;
            } else {
                const numbersOnly = `
                    <div style="display: flex; flex-direction:column; align-items: center; justify-content: center; width: 100%; height: 50px;">
                        <div style="font-family: 'Poppins', sans-serif; padding: 4px 8px; border-radius: 50%; overflow: hidden; background: #fff; width: 30px; height: 30px;">
                            <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;font-weight: 600; font-size: 13px; color: #111827;">
                                ${polygon.roofNumber}
                            </div>
                        </div>
                    </div>
                `;
                polygon.labelContent = numbersOnly;
            }
        });
        applyLabelsWithCollisionDetection();
    }

    /**
     * Toggle group expansion for inline display
     * @param {string} groupId - The group ID to toggle
     */
    window.toggleGroupExpansion = function (groupId) {
        const groupRows = document.querySelectorAll('.' + groupId);
        const toggleBtn = document.getElementById('toggle_' + groupId);
        const icon = toggleBtn?.querySelector('.icon');

        // Check if group is currently expanded (any child row is visible)
        const isExpanded = Array.from(groupRows).some(row => row.style.display !== 'none');

        if (isExpanded) {
            // Collapse group
            groupRows.forEach(row => {
                row.style.display = 'none';
            });
            // Rotate icon back (or remove rotation class)
            if (icon) {
                icon.style.transform = 'rotate(0deg)';
            }
        } else {
            // Expand group
            groupRows.forEach(row => {
                row.style.display = 'table-row';
            });
            // Rotate icon 90 degrees
            if (icon) {
                icon.style.transform = 'rotate(90deg)';
            }
        }
    };
    initMap();
});
